import { useEffect, useState } from 'react';

export default function DomotiqueHero() {
  const [isFlashing, setIsFlashing] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFlashing(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20smart%20home%20automation%20system%20with%20elegant%20touchscreen%20control%20panel%20mounted%20on%20minimalist%20white%20wall%2C%20sleek%20contemporary%20interior%20design%20with%20ambient%20lighting%2C%20clean%20professional%20technology%20aesthetic%2C%20high-end%20residential%20automation%20interface%20showing%20climate%20and%20lighting%20controls%2C%20sophisticated%20home%20technology%20integration&width=1920&height=600&seq=domotique-hero-bg-001&orientation=landscape"
          alt="Domotique et Automatisation"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8 py-32 text-center">
        <span className="inline-block bg-orange-500/20 border border-orange-500/40 text-orange-400 text-sm font-semibold px-4 py-1.5 rounded-full mb-6">
          Domotique & Automatisation · Genève
        </span>
        <h1 className={`text-5xl md:text-6xl font-bold text-white mb-6 transition-opacity duration-300 ${isFlashing ? 'animate-pulse' : ''}`}>
          Domotique et <span className="text-orange-400">Automatisation</span>
        </h1>
        <p className="text-xl md:text-2xl text-white/80 max-w-3xl mx-auto mb-8">
          Transformez votre habitat en maison intelligente avec nos solutions domotiques sur mesure pour la Suisse
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <a
            href="#contact"
            className="bg-orange-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Demander un devis
          </a>
          <a
            href="mailto:info@hbservices.ch"
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold border border-white/20 hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line mr-2"></i>
            info@hbservices.ch
          </a>
        </div>
      </div>
    </section>
  );
}
